var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"root",staticClass:"timelineEvent"},[_c('timeline',{ref:"timeline",attrs:{"items":_vm.items,"options":_vm.options,"events":[
      'rangechange',
      'rangechanged',
      'mouseDown',
      'timechange',
      'timechanged',
      'select' ]},on:{"dragover":function($event){_vm.mouseover = true},"mousedown":function($event){$event.preventDefault();_vm.mouseover = true}}}),_c('div',{staticClass:"timelineEvent-trim",style:({
      left: _vm.frameRect.left + 'px',
      width: _vm.frameRect.width + 'px',
    })})],1)}
var staticRenderFns = []

export { render, staticRenderFns }